function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.253 9.301a.6.6 0 010 .849L13.13 15.27a1.6 1.6 0 01-2.262 0l-5.12-5.12a.6.6 0 11.849-.848l5.12 5.12a.4.4 0 00.565 0L17.404 9.3a.6.6 0 01.849 0z",
  fill: "currentColor"
});

function SvgIconOptionSelectDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOC4yNTI3IDkuMzAxMjJDMTguNDg3IDkuNTM1NTQgMTguNDg3IDkuOTE1NDQgMTguMjUyNyAxMC4xNDk4TDEzLjEzMTQgMTUuMjcxMUMxMi41MDY1IDE1Ljg5NTkgMTEuNDkzNSAxNS44OTU5IDEwLjg2ODYgMTUuMjcxMUw1Ljc0OTE2IDEwLjE1MTZDNS41MTQ4NSA5LjkxNzMxIDUuNTE0ODUgOS41Mzc0MSA1Ljc0OTE2IDkuMzAzMDlDNS45ODM0OCA5LjA2ODc4IDYuMzYzMzggOS4wNjg3OCA2LjU5NzY5IDkuMzAzMDlMMTEuNzE3MSAxNC40MjI1QzExLjg3MzQgMTQuNTc4OCAxMi4xMjY2IDE0LjU3ODggMTIuMjgyOCAxNC40MjI1TDE3LjQwNDIgOS4zMDEyMkMxNy42Mzg1IDkuMDY2OTEgMTguMDE4NCA5LjA2NjkxIDE4LjI1MjcgOS4zMDEyMloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgIconOptionSelectDown as ReactComponent };